// REQ-FE-037 item 9 — 2-letter avatar initials matching mockup.
// "Adrien Lutun" → "AL", "alutun@altyor.com" → "AL" (best-effort
// before-@ split). Fallback to '?' when name is empty.
export function initials(displayName: string): string {
  const raw = (displayName ?? '').trim();
  if (!raw) return '?';
  const beforeAt = raw.includes('@') ? (raw.split('@')[0] ?? raw) : raw;
  const tokens = beforeAt.split(/[\s._-]+/).filter(Boolean);
  if (tokens.length >= 2) {
    return ((tokens[0]?.[0] ?? '') + (tokens[1]?.[0] ?? '')).toUpperCase();
  }
  const single = tokens[0] ?? raw;
  return single.slice(0, 2).toUpperCase();
}
